/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: bbqin
 * @LastEditTime: 2022-06-21 14:57:07
 * @Description: file content
 */
import {
    setGlobalStorage,
    getGlobalStorage,
    removeGlobalStorage,
} from './storage';
import { setCookie, getCookie } from './cookie';

const namespace = '__cachetools__';
function set(key, val) {
    if (typeof val === 'undefined') {
        return;
    }

    key = namespace + key;
    try {
        setGlobalStorage(
            'sessionStorage',
            key,
            JSON.stringify(val),
        );
    } catch (e) {
        console.error('sessionStorage容量溢出');
        //remove(key);
        // set(key, val);
    }
}

function get(key) {
    key = namespace + key;
    let session = getGlobalStorage('sessionStorage', key);
    if (session) {
        session = JSON.parse(session);
        console.log("cacheTools.get", session);
        return session;
    }

    return null;
}

function remove(key) {
    key = namespace + key;
    removeGlobalStorage('sessionStorage', key);
}

/**
 * 清模板缓存，登录页切换语种时使用 by renyjk
 */
function clearTemplet() {
    Object.keys(localStorage).forEach(e => {
        if (String(e).includes('appTempletStorage_')) {
            delete localStorage[e];
        }
    });
}

/**
 * 清除cachetools存的
 */
function clearCachetools() {
    Object.keys(sessionStorage).forEach(e => {
        if (String(e).includes(namespace)) {
            delete sessionStorage[e];
        }
    });
}

function clear(keysArr, isClearTemplet = false) {
    // 清除NCCAPPURL的同时一定要清除browserTabs，避免两者数据不一致导致的异常错误
    removeGlobalStorage('sessionStorage', 'browserTabs');
    removeGlobalStorage('sessionStorage', 'NCCAPPURL');
    // removeGlobalStorage('sessionStorage', 'NCCSessionStorage');
    clearCachetools();
    let exceptLocalKeys = [
        'ColumnConfig',
        'CommonColumnConfig',
        'referTreeConfig',
        'referHistory',
        'rockin',
        '_ncc_automated_',
        '_ncc_pagesize_store',
        'fold_flag',
        'userloginid',
        'langCode',
        'busiCenterCode',
        'showLable',
        'storeCipher',
        'gzip',
        'zoom',
        'referModalSize',
        'plRecordTime',
        'zoomValue',
        'global_search',
        'designerEntered',
        'DropActiveKey',
        'ColumnConfigWidth',
        'NCCAPPURL',
        'flat_table',
        'autoSearchConfig',
    ];
    Object.keys(localStorage)
        .filter(e => {
            let res =
                // local中的所有例外(不被清除)标识  如 cowboy-*
                String(e).indexOf('cowboy') !== -1 ||
                // local中的所有例外(不被清除)标识  如 retain-*
                String(e).indexOf('retain') !== -1 ||
                // local中的所有例外(不被清除)标识  如 customer_drag_* 上下分栏 左右分栏 缓存
                String(e).indexOf('customer_drag_') !== -1 ||
                // local中的所有例外(不被清除)标识  如 form_card_container_expand* 表单关键信息区 缓存
                String(e).indexOf('form_card_container_expand') !== -1 ||
                exceptLocalKeys.includes(e) ||
                // local中不清除模板缓存
                (!isClearTemplet && String(e).includes('appTempletStorage_'));
            return !res;
        })
        .forEach(e => delete localStorage[e]);
    let allCookies = getCookie();
    let exceptKeys = ['userloginid', 'langCode', 'busiCenterCode'];
    if (keysArr && keysArr instanceof Array) {
        exceptKeys = keysArr;
    }
    for (let cookieKey in allCookies) {
        if (!exceptKeys.includes(cookieKey)) {
            setCookie(cookieKey, null, null, null, -1);
        }
    }
}

export { set, get, remove, clear, clearTemplet };
